import { withAppContext } from '@/config/site'
import request from '@/utils/request'

/**
 * 获取章节教材列表
 * @param {number} courseId - 课程ID
 * @param {number} chapterId - 章节ID
 * @param {object} payload - 其他参数
 * @returns {Promise<array>} 教材列表
 */
export const fetchChapterTextbookList = async (courseId, chapterId, payload = {}) => {
  const response = await request('/page/course/textbook/index', {
    data: withAppContext({
      course_id: courseId,
      chapter_id: chapterId,
      ...payload
    })
  })

  return Array.isArray(response.data) ? response.data : []
}

/**
 * 获取教材详情（含目录）
 * @param {number} id - 教材ID
 * @param {object} payload - 其他参数
 * @returns {Promise<object>} 教材详情
 */
export const fetchTextbookDetail = async (id, payload = {}) => {
  const response = await request('/page/course/textbook/detail', {
    data: withAppContext({
      id,
      ...payload
    })
  })

  return response.data || {}
}

/**
 * 获取教材阅读器配置
 * @param {number} id - 教材ID
 * @param {object} payload - 其他参数
 * @returns {Promise<object>} 阅读器配置
 */
export const fetchTextbookPreviewConfig = async (id, payload = {}) => {
  const response = await request('/page/course/textbook/preview-config', {
    data: withAppContext({
      id,
      ...payload
    })
  })

  return response.data || {}
}

/**
 * 上传文档并获取智能解析结果。
 * @param {File} file - 教材文件二进制
 * @returns {Promise<object>} TextIn 解析结果
 */
export const parseTextbookDocument = async (file) => {
  if (!(file instanceof File) || file.size <= 0) {
    throw new Error('教材文件无效，无法开始智能解析。')
  }

  const formData = new FormData()
  formData.append('file', file)

  const response = await request('/page/textin/document/parse', {
    data: formData,
    timeout: 150000
  })

  return response.data || {}
}

const textbookProgressRequest = async (action, textbookId, payload = {}) => {
  const response = await request(`/page/course/textbook/progress/${action}`, {
    data: withAppContext({
      textbook_id: textbookId,
      ...payload
    })
  })

  return response.data || {}
}

export const openTextbookProgress = (textbookId, payload = {}) =>
  textbookProgressRequest('open', textbookId, payload)

export const fetchTextbookProgress = (textbookId, payload = {}) =>
  textbookProgressRequest('detail', textbookId, payload)

export const fetchTextbookPages = (textbookId, payload = {}) =>
  textbookProgressRequest('pages', textbookId, payload)

export const turnTextbookPage = (textbookId, payload = {}) =>
  textbookProgressRequest('turn', textbookId, payload)

export const completeTextbookProgress = (textbookId, payload = {}) =>
  textbookProgressRequest('complete', textbookId, payload)
